module.exports = __webpack_public_path__ + "static/media/restaurant2.269dd27c.jpg";